<template>
  <div class="bind">
    <!-- <div v-if="isSuccess" class="bind-box">
      <van-icon name="warning" class="bind-icon" />
      您已绑定过操作员，请勿重复绑定
    </div> -->
    <div class="bind-box" v-if="isSuccess == 1">
      <van-icon class="bind-icon" name="warning" />
      您确认绑定吗？
      <van-button style="margin:50px 0 20px;" type="primary" block @click="bind"
        >确认</van-button
      >
      <van-button type="default" plain hairline block @click="cancel"
        >取消</van-button
      >
    </div>
    <div class="bind-box passed-box" v-else-if="isSuccess == 2">
      <van-icon class="bind-icon" name="passed" />
      绑定成功
    </div>
    <div class="bind-box warning-box" v-else-if="isSuccess == 3">
      <van-icon class="bind-icon" name="warning-o" />
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import { Button, Icon, Dialog } from "vant";
import {
  getRedirectFullUrl,
  getUserInfoCallback,
  SaveUserOpenId,
} from "@/api/auth.js";
export default {
  name: "bindWechat",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      urlParams: {},
      isSuccess: 1,
      show: false,
      errorMsg: "",
    };
  },
  created() {
    const urlParams = this.$route.query;
    const code = urlParams.code;
    if (code) {
      this.bind();
    }
  },
  methods: {
    bind() {
      const code = this.$route.query.code;
      let url = window.location.href;
      if (versionConfig.ZHIYUN_VERSION && versionConfig.WECHAT_AUTHORURL) {
        url =
          versionConfig.WECHAT_AUTHORURL +
          window.location.pathname +
          window.location.search;
      }
      const keyId = this.$route.query.KeyId;
      const userId = this.$route.query.UserId;
      if (!code) {
        let CompanyCode = this.$route.query.CompanyCode;
        let params = {
          ReturnUrl: url,
          IsZYPlus: versionConfig.ZHIYUN_VERSION,
        };
        if (CompanyCode) {
          params.CompanyCode = CompanyCode;
        }
        getRedirectFullUrl({
          ReturnUrl: url,
          IsZYPlus: versionConfig.ZHIYUN_VERSION,
        }).then(res => {
          window.location.href = res.Data;
        });
      } else {
        getUserInfoCallback({
          Code: code,
          KeyId: keyId,
          IsZYPlus: versionConfig.ZHIYUN_VERSION,
        }).then(res => {
          if (res.Data && userId) {
            // this.isSuccess = true;
            SaveUserOpenId({
              UserId: userId,
              OpenId: res.Data.openid,
              NickName: res.Data.nickname,
            })
              .then(() => {
                this.isSuccess = 2;
              })
              .catch(error => {
                this.isSuccess = 3;
                this.errorMsg = error.message;
              });
          } else {
            this.isSuccess = 3;
            this.errorMsg = "未绑定微信号，请先去系统中绑定微信号";
          }
        });
      }
    },
    cancel() {
      this.isSuccess = 3;
      this.errorMsg = "您已取消绑定操作";
    },
  },
};
</script>

<style lang="less" scoped>
.bind-box {
  margin-top: 50px;
  font-size: 18px;
  text-align: center;
  width: 80%;
  margin-left: 10%;
  .bind-icon {
    font-size: 100px;
    display: block;
    color: #44b549;
    margin-bottom: 15px;
  }
}
.passed-box {
  margin-top: 100px;
  font-size: 22px;
  color: #0aa510;
  .bind-icon {
    font-size: 140px;
  }
}
.warning-box {
  margin-top: 100px;
  font-size: 22px;
  color: #ff9e00;
  .bind-icon {
    font-size: 140px;
    color: #ff9e00;
  }
}
</style>
